module.exports = __webpack_public_path__ + "img/quality-policy.d44f6abe.jpg";